// removed by extract-text-webpack-plugin
module.exports = {"container":"_1ZcXB","table":"_3_bxl","tdTitle":"_1pLho","tr":"jXMpI","title":"_1r5Ad","description":"_1Q8PF","tdInformation":"jn4LT","tdToggle":"PnV-l"};


//////////////////
// WEBPACK FOOTER
// ./app/components/notifications-settings/notifications-settings.scss
// module id = 1749
// module chunks = 0